// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.top-bar[data-v-4d84789c] {\n  width: 100%;\n}\n.top-bar-selector[data-v-4d84789c] {\n  width: 150px;\n}", ""]);
// Exports
module.exports = exports;
